import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4ac8fd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _mergeProps({ id: _ctx.id }, _ctx.attributes, {
    class: ["col-form-label text-gray-700 fw-bold", { required: _ctx.attributes.required, 'no-click': _ctx.attributes.disabled }]
  }), _toDisplayString(_ctx.content), 17, _hoisted_1))
}